import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";

export const ManageEventParticipantsApiSlice = createApi({
  reducerPath: "manageEventParticipantsApiSlice",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    manageEventEnrollments: builder.query({
      query: ({ eventId, body }) => ({
        url: `/enrollment/manage/${eventId}`,
        method: "POST",
        body: body
      }),
      extraOptions: { service: "TMS" }
    })
  }),
  refetchOnMountOrArgChange: true,
  refetchOnFocus: true
});

export const {
  useManageEventEnrollmentsQuery,
  useLazyManageEventEnrollmentsQuery,
} = ManageEventParticipantsApiSlice;
